//src/redux/slices/popupSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialPopupState = {
  header: '',
  message: '',
  button: '',
  open: false,
  toastMessage: '',
  callbackFn: () => {},
};

const popupSlice = createSlice({
  name: 'popup',
  initialState: initialPopupState,
  reducers: {
    clearPopupState: () => initialPopupState,
    sessionTimeout: (state, { payload }) => {
      state.header = 'Session timeout!';
      state.message =
        'Your current session has been expired due to inactivity. Please login again to continue.';
      state.button = 'Login';
    },
    sessionTimeoutWarning: (state, { payload }) => {
      state.header = 'Session timeout warning!';
      state.message =
        'Your current session will expire in 5 minutes due to inactivity. Please click ‘Okay’ to continue being logged in.';
      state.button = 'Okay';
    },
    internalServerError: (state, { payload }) => {
      state.header = 'Server error!';
      state.message =
        "Looks like there's an error with our server. Please try again later.";
      state.button = 'Ok';
    },
    clientSideError: (state, { payload }) => {
      state.header = 'An error occured!';
      state.message = 'Looks like an error occured. Please try again!';
      state.button = 'Ok';
    },
    jwtExpiryTimeout: (state, { payload }) => {
      state.header = 'Session expired!';
      state.message =
        'Your current session has been expired due to inactivity. Please login again to continue.';
      state.button = 'Login';
    },
    openPopup: (state, { payload }) => {
      state.open = true;
    },
    closePopup: (state, { payload }) => {
      state.open = false;
      clearPopupState();
    },
    setCallbackFn: (state, { payload }) => {
      state.callbackFn = payload;
    },
    clearToastMessage: (state) => {
      state.toastMessage = '';
    },
    setToastMessage: (state, { payload }) => {
      state.toastMessage = payload;
    },
    setCustomPopupContent: (state, { payload }) => {
      state.header = payload.header;
      state.message = payload.message;
      state.button = payload.button;
    },
  },
});

export const {
  clearPopupState,
  sessionTimeout,
  sessionTimeoutWarning,
  internalServerError,
  clientSideError,
  openPopup,
  closePopup,
  setCallbackFn,
  jwtExpiryTimeout,
  clearToastMessage,
  setToastMessage,
  setCustomPopupContent,
} = popupSlice.actions;
export default popupSlice.reducer;
